export enum UserEnum {
  GUEST = "guest",
  USER = "user",
  ADMIN = "admin",
}

export type SignUpPropertiesTypes = {
  fullname: string;
  email: string;
  password: string;
};
